<template>
    <div class="main_center" style="margin: 0 0;padding-top: 8px;">
        <div class="content" style="padding: 16px 16px 5px 16px;">
            <el-form ref="form" :model="form" label-width="100px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="所属区域：">
                            <el-select v-model="form.regionId" clearable placeholder="请选择所属区域"
                                       style="width: 100%;">
                                <el-option v-for="(item, index) in regionOptions"
                                           :key="index"
                                           :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="承办部门：">
                            <el-select v-model="form.undertakeDept" clearable placeholder="请选择承办部门"
                                       style="width: 100%;">
                                <el-option v-for="(item, index) in undertakeDeptOptions"
                                           :key="index"
                                           :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="关键字：" props="searchKey">
                            <el-input v-model="form.searchKey" clearable
                                      placeholder="请输入项目名称、招标（采购）人、中标单位进行搜索"
                                      @keyup.enter.native="searchBtn"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="">
                            <div>
                                <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                                <el-button size="small" type="primary" @click="searchBtn">搜索</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <space :left="-16" :right="-16" :bottom="16"/>

            <el-table :data="tableData"
                      v-loading="dataListLoading"
                      ref="expertExtractTable"
                      :height="tableMaxHeight"
                      stripe border
            >
                <el-table-column label="序号" type="index" :index="indexMethod" width="60"
                                 align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="所属区域" prop="regionCode" align="left" width="120">
                    <template slot-scope="scope">
                        <span>{{scope.row.regionCode | regionFilter}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="项目名称" prop="projectName" align="left" min-width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="招标（采购）人" prop="tendererName" align="left"
                                 width="150px" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="预算金额" prop="budgetAmount" align="left" width="180px"></el-table-column>
                <el-table-column label="承办部门" prop="undertakeDept" align="left" width="150px">
                    <template slot-scope="scope">
                        <span>{{scope.row.undertakeDept | undertakeDeptFilter}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="开标时间" prop="openStartTime" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="开标场地" prop="openVenue" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="评标时间" prop="evalStartTime" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="评标场地" prop="evalVenue" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="中标单位" prop="winningCompany" align="left" width="150px"></el-table-column>
                <el-table-column label="中标金额" prop="winningAmount" align="left" width="150px"></el-table-column>
                <el-table-column label="创建时间" prop="createTime" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="修改时间" prop="updateTime" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange"
            >
            </pagination>
        </div>
    </div>
</template>

<script>
import space from "@/views/common/components/space.vue";
import Pagination from "@/components/Pagination";

export default {
    name: "projectList",
    components: {
        space,
        Pagination,
    },
    data() {
        return {
            form: {
                searchKey: "",
                undertakeDept: "",
                regionId: "",
            },
            regionOptions: [
                { value: 421201, label: '咸宁市本级' },
                { value: 421202, label: '咸安区' },
                { value: 421221, label: '嘉鱼县' },
                { value: 421222, label: '通城县' },
                { value: 421223, label: '崇阳县' },
                { value: 421224, label: '通山县' },
                { value: 421281, label: '赤壁市' },
            ],
            undertakeDeptOptions: [
                {value: 1, label: '工程建设部'},
                {value: 2, label: '政府采购部'},
                {value: 3, label: '资源与产权交易部'},
            ],
            businessType: "GC",
            moreSearchItem: false,
            tableData: [],
            pageIndex: 1,
            pageSize: 12,
            total: 0,
            dataListLoading: false,
            tableMaxHeight: document.documentElement.clientHeight - 318,
            sortParams: {
                prop: '',
                order: ''
            },
            businessTypeNamelist: [], // 业务类型选择列表
            multipleSelection: [],
        };
    },
    filters: {
        regionFilter(regionId) {
            const map = {
                421200: '咸宁市',
                421201: '咸宁市本级',
                421202: '咸安区',
                421221: '嘉鱼县',
                421222: '通城县',
                421223: '崇阳县',
                421224: '通山县',
                421281: '赤壁市',
            }
            return map[regionId] || ''
        },
        statusFilter(status) {
            //1 未提交 2 受理中 3 承办中 8 已完成 9 已退回
            switch (status) {
                case 1:
                    return '未提交';
                case 2:
                    return '受理中';
                case 3:
                    return '承办中';
                case 8:
                    return '已完成';
                case 9:
                    return '已退回';
                default:
                    return '';
            }
        },
        undertakeDeptFilter(status) {
            //1 工程建设部 2 政府采购部 3 资源与产权交易部
            switch (status) {
                case '1':
                    return '工程建设部';
                case '2':
                    return '政府采购部';
                case '3':
                    return '资源与产权交易部';
                default:
                    return '';
            }
        },
    },
    activated() {
        this.getListData();
    },
    mounted() {
        this.ifmove();
        let resizeTag = true;
        let that = this;
        window.onresize = () => {
            if (resizeTag) {
                //防抖动
                that.ifmove();
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 1000);
            }
        };
    },
    methods: {
        //获取列表数据
        getListData() {
            this.$http.post(`/TradingOverview/getTradingOverviewList`, {
                page: this.pageIndex,
                rows: this.pageSize,
                searchKey: this.form.searchKey,
                filter: {
                    regionId: this.form.regionId,
                    undertakeDept: this.form.undertakeDept,
                },
            }).then((res) => {
                this.tableData = res.data.rows;
                this.total = res.data.total;
            });
        },
        //分页
        paginationChange({page, limit}) {
            this.pageIndex = page;
            this.pageSize = limit;
            this.getListData();
        },
        //序号
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        // 判断行是否可选择
        isSelectable(row) {
            return row.status === 1;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        ifmove() {
            let tableMaxHeight = document.documentElement.clientHeight - 318;
            this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight;
            });
        },
        //搜索
        searchBtn() {
            this.pageIndex = 1;
            this.getListData();
        },
        //重置
        reflash() {
            this.form = {
                searchKey: "",
                undertakeDept: "",
                regionId: "",
            };
            this.pageIndex = 1;
            this.getListData();
        },
        //新增
        onClickAdd() {
            this.$router.push({
                name: "singleWindowServiceProjectAdd",
            });
        },
        //查看
        onClickGoToView(row) {
            this.hasEditPermission(row).then((hasPermission) => {
                if (row.status === 1 || (row.status === 9 && hasPermission)) { //未提交、已退回，进到新增页面
                    this.$router.push({
                        name: "singleWindowServiceProjectAdd",
                        query: {
                            id: row.id,
                        }
                    });
                }else { //进到审批页
                    this.$router.push({
                        name: "singleWindowServiceProjectDetail",
                        query: {
                            id: row.id,
                        }
                    });
                }
            })

        },
        //删除
        onClickDeleteRow(row) {
            this.$confirm('确认删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post(`/projectEntry/batchDelete`, [row.id]).then(({data}) => {
                    if (data.code === '1') {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getListData();
                    }else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        //批量删除
        onClickMultiDelete() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: '请选择要删除的项目',
                    type: 'warning'
                });
                return;
            }
            this.$confirm(`确认删除选中的${this.multipleSelection.length}个项目吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const projectEntryRegisterIds = this.multipleSelection.map(item => item.id)
                this.$http.post(`/projectEntry/batchDelete`, projectEntryRegisterIds).then(({data}) => {
                    if (data.code === '1') {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getListData();
                        this.multipleSelection = [];
                    }else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        //判断是否有编辑权限
        hasEditPermission(row) {
            return new Promise((resolve, reject) => {
                this.$http.get(`/projectEntry/hasEditPermission?id=${row.id}`).then(({data}) => {
                    if (data.code === '1') {
                        resolve(data.data)
                    }else {
                        reject(data.msg)
                    }
                })
            })
        },
    },
};
</script>


<style lang="less" scoped>
::v-deep .main_center .content {
    padding: 10px 10px 0 10px !important;
}
</style>
